import Vue from 'vue';
import api from '../../api';
import asyncForEach from '../../utils/asyncForEach';

const state = {
  docs_for_edit: [],
};

const getters = {
  docs_for_edit(state) {
    return state.docs_for_edit;
  },
};

const mutations = {
  deleteDocForEdit(state, payload) {
    const index = findDoc(state.docs_for_edit, payload);

    if (index >= 0) {
      Vue.delete(state.docs_for_edit, index);
    }
  },
  setDocsForEdit(state, payload) {
    state.docs_for_edit = payload;
  },
  setDocForEdit(state, payload) {
    const index = findDoc(state.docs_for_edit, payload);

    if (index >= 0) {
      // udpate existing doc
      Vue.set(state.docs_for_edit, index, payload);
    } else {
      // add new doc
      state.docs_for_edit.push(payload);
    }
  },
};

const actions = {
  deleteDocForEdit(context, payload) {
    context.commit('deleteDocForEdit', payload);
  },
  setDocsForEdit(context, payload) {
    context.commit('setDocsForEdit', payload);
  },
  setDocForEdit(context, payload) {
    context.commit('setDocForEdit', payload);
  },
  saveDocsForEdit(context, project_id) {
    return new Promise(async (resolve, reject) => {
      try {
        const payload = context.getters.docs_for_edit;

        const new_docs = getNewDocs(payload, project_id);
        const updated_docs = getUpdatedDocs(payload, project_id, context);
        const deleted_keys = getDeletedDocIds(payload, project_id, context);

        if (new_docs.length) {
          await api.saveNewDocuments(new_docs);
        }

        await asyncForEach(updated_docs, async doc => {
          const udpate_doc = JSON.parse(JSON.stringify(doc));
          const id = udpate_doc.id;
          delete udpate_doc.id;
          await api.updateDocument(udpate_doc, id);
        });

        await asyncForEach(deleted_keys, async doc => {
          await api.deleteDocument(doc);
        });

        context.commit('setDocsForEdit', []);
        resolve();
      } catch (e) {
        console.error(e);
        reject(e);
      }
    });
  },
};

const getNewDocs = (payload, project_id) => {
  if (!payload || !payload.length) return [];

  return payload
    .filter(doc => doc.id < 0)
    .map(doc => {
      return {
        url: doc.url,
        type: doc.type,
        title: doc.title,
        description: doc.description,
        projectId: project_id,
      };
    });
};

const getUpdatedDocs = (payload, project_id, context) => {
  try {
    let project = null;
    Object.keys(context.getters.projects).forEach(p => {
      const this_project = context.getters.projects[p];
      if (this_project.id === project_id) {
        project = this_project;
      }
    });

    if (project && project.projectDocuments) {
      const updated_docs = [];

      payload.forEach(doc => {
        const original_doc = project.projectDocuments.find(
          d => d.id === doc.id
        );
        if (!original_doc) return;

        const url_changed = original_doc.url !== doc.url;
        const type_changed = original_doc.type !== doc.type;
        const title_changed = original_doc.title !== doc.title;
        const description_changed =
          original_doc.description !== doc.description;

        if (
          url_changed ||
          type_changed ||
          title_changed ||
          description_changed
        ) {
          const updated_doc = {
            type: doc.type,
            title: doc.title,
            description: doc.description,
            url: doc.url,
            id: doc.id,
          };
          updated_docs.push(updated_doc);
        }
      });

      return updated_docs;
    }

    return [];
  } catch (e) {
    console.error(e);
    return [];
  }
};

const getDeletedDocIds = (payload, project_id, context) => {
  try {
    let project = null;
    Object.keys(context.getters.projects).forEach(p => {
      const this_project = context.getters.projects[p];
      if (this_project.id === project_id) {
        project = this_project;
      }
    });

    if (project && project.projectDocuments) {
      const original_doc_keys = project.projectDocuments.map(d => d.id);
      const payload_keys = payload.map(d => d.id);
      return original_doc_keys.filter(key => !payload_keys.includes(key));
    }

    return [];
  } catch (e) {
    console.error(e);
    return [];
  }
};

const findDoc = (docs, payload) => {
  let i = -1;

  docs.forEach((d, index) => {
    if (d.id === payload.id) {
      i = index;
    }
  });

  return i;
};

export default {
  state,
  getters,
  mutations,
  actions,
};
